






















































































import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "App",

  data: () => ({
    drawer: false,
    snackbar: false,
    registration: {} as ServiceWorkerRegistration,
    updated: false,
  }),

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });
  },

  methods: {
    logout: async function () {
      try {
        let response = await fetch(`${this.$api}/logout`, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
        });

        this.$store.dispatch("resetUser");
        this.$router.push("/login");
      } catch (e) {
        console.error(e);
      }
    },
    updateAvailable(event: any) {
      this.registration = event.detail;
      this.snackbar = true;
    },
    updateApp() {
      this.snackbar = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      this.updated = true;
    },
    goTo(site: string) {
      window.location.replace(site);
    },
  },
});
